<script>
export default {
  name: 'ImageListItem',
  props: {
    disabled: Boolean,
    src: String,
    alt: String,
    hidden: Boolean,
    infoLink: String,
    selected: Boolean
  },
  data() {
    return {
      isError: false,
      isLoaded: false
    };
  },
  mounted() {
    const image = this.$refs.image;

    // Wait for the image to load
    if (image.complete) {
      this.isLoaded = true;
    } else {
      image.onload = () => this.isLoaded = true;
      image.onerror = () => this.isError = true;
    }
  },
  methods: {
    handleClick(event) {
      // Don't emit clicks for disabled images
      if (this.disabled) {
        return;
      }

      this.$emit('click', event);
    }
  }
};
</script>

<template>
  <div
    v-loading="!isLoaded"
    :class="{
      'image-list-item': true,
      'is-disabled': disabled,
      'is-error': !isError,
      'is-hidden': hidden,
      'is-selected': selected
    }"
    @click="handleClick"
    @dblclick="$emit('dblclick', $event)"
  >
    <a class="primary-link" href="#" @click.prevent>
      <img ref="image" :src="src" :alt="alt">
    </a>
    <a
      v-if="infoLink"
      :href="infoLink"
      :title="$t('View Info')"
      class="info-link"
      target="_blank"
      rel="noopener"
    >
      <i class="el-icon-fa-info-circle" />
    </a>
  </div>
</template>

<style lang="scss" scoped>
@import '@/styles/variables.scss';

.image-list-item {
  position: relative;
  padding: .25rem;
  margin: 0;
  float: left;

  .primary-link {
    display: block;
    cursor: default;

    img {
      display: block;
      width: 100%;
      height: 8rem;
      object-fit: cover;
      border-radius: .15rem;
    }

    @include breakpoint('sm-and-down') {
      img {
        height: 6rem;
      }
    }
  }

  .info-link {
    display: none;
    position: absolute;
    bottom: .25rem;
    right: .25rem;
    color: $--color-white;
    padding: .25rem;
  }

  &.is-disabled {
    img {
      filter: grayscale(100%);
      opacity: .75;
    }
  }

  &.is-hidden {
    display: none;
  }

  &.is-selected {
    .primary-link {
      img {
        outline: solid 3px $--color-primary;
        border-radius: 0;
      }
    }

    .info-link {
      display: block;
    }
  }
}
</style>
